import { useAddAssignmentMarkMutation } from "../redux/features/assignments/assignmentMarkAPI";
import { useState } from "react";
import Error from "./Error";

export default function AssignmentModal({ open, control, assignment }) {
  const { id: assignment_id, title, totalMark } = assignment;
  const { id: student_id, name: student_name } = JSON.parse(
    localStorage.auth
  ).user;

  const [addAssignmentMark, { isLoading, isError, error }] =
    useAddAssignmentMarkMutation();

  const [repository, setRepository] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!window.confirm("Are you sure you want to submit?")) return;

    addAssignmentMark({
      student_id,
      student_name,
      assignment_id,
      title,
      createdAt: new Date().toISOString(),
      totalMark: parseInt(totalMark),
      mark: 0,
      repo_link: repository,
      status: "pending",
    });

    control(assignment);
  };

  return (
    open && (
      <div
        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          className="relative w-auto my-6 mx-auto max-w-3xl"
          style={{
            borderRadius: "0.5rem",
            boxShadow: "0 5px 10px rgba(0,0,0,0.12)",
            width: "500px",
            // width: "33%",

            backgroundColor: "#141414",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            border: "2px solid rgba(0,0,0,0.12)",
          }}
        >
          <div className="flex mt-4 p-4" style={{ backgroundColor: "#141414" }}>
            <h3 className="text-xl font-semibold">
              <span className="text-cyan">এসাইনমেন্ট</span> জমা দিন
            </h3>

            <button
              className="px-2 ml-auto text-white float-right leading-none font-semibold outline-none 
              hover:text-black focus:outline-none transition-transform duration-300 ease-in-out transform hover:scale-110"
              type="button"
              onClick={control}
            >
              <span className="sr-only">Close menu</span>

              <svg
                className="h-6 w-6 close-menu"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div className="text-xl p-4 flex">{title}</div>

          <form className="px-4 py-4" onSubmit={(e) => handleSubmit(e)}>
            <input type="hidden" name="remember" value="true" />
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label htmlFor="link" className="mt-2 py-2 text-sm flex">
                  গিটহাব রিপোজিটরি লিঙ্ক
                </label>
                <input
                  id="link"
                  name="link"
                  type="url"
                  autoComplete="link"
                  value={repository}
                  required
                  style={{ color: "black", backgroundColor: "white" }}
                  className="w-full p-2 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-cyan focus:border-cyan"
                  placeholder="Enter Repository Link"
                  onChange={(e) => setRepository(e.target.value)}
                />
              </div>
            </div>

            <div className="py-6 flex items-center justify-center">
              <button
                className=" px-5 py-2 font-bold border border-cyan text-primary rounded-full text-sm hover:bg-cyan hover:text-primary"
                disabled={isLoading}
                type="submit"
              >
                জমা দিন
              </button>
            </div>

            {isError && <Error message={error} />}
          </form>
        </div>
      </div>
    )
  );
}
